// extracted by mini-css-extract-plugin
module.exports = {"MenuIdea_title":"MenuIdeasTitle_MenuIdea_title__1dimG"};